<template>
    <div class="email-content-container">
        <div class="wrapper d-flex flex-column">
            <img src="@/assets/logo_pink.png" alt="">

            <div class="content">
                Hello venue <span class="font-weight-bold">Nodo Camper Hills,</span><br><br>
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                Here is the End of the day report as of Wednesday, 16th day of August 2023.
                <br><br>
                Please see attached link and url below.
                <br><br>

                <a href="www.venue.peiso.com.au/report/eod/8923iklj2kk3h">www.venue.peiso.com.au/report/eod/8923iklj2kk3h</a>
                <br>
                The password is <span class="password">029134</span>.
                <br><br>


                <span class="small-text">This is an automated report email. Please do not replay.</span>
                <br><br><br>
                PEISO Team
            </div>
        </div>
    </div>
</template>

<style lang='scss'>
@import 'static/scss/email';
    
</style>

<script>
    export default {
        data() {
            return {
            }
        },
        props: {
            
        },
        watch: {
            
        },
        computed: {
            
        },
        methods: {
            
        },
        mounted() {
            
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/report/emailContent/index.vue